import { RawDataTimeSeries } from '@/components/RawData';
import { useHealthTranslations } from '../../hooks/useHealthTranslations';
import { useDateFormatter } from '@/hooks/useDateFormatter';
import { useMemo } from 'react';
import { useLocale } from '@/hooks/useLocale';

export interface Props {
  uniqueSymbol: string;
  reportingCurrencyISO: string;
  reportingUnit: string;
  lastEarningsUpdate: number;
  companyShortName: string;
  pastDebtAndEquityData: { dateKey: number; data: number[] }[];
}

const HistoricalDebtEquityRawData = ({
  uniqueSymbol,
  reportingCurrencyISO,
  reportingUnit,
  lastEarningsUpdate,
  companyShortName,
  pastDebtAndEquityData,
}: Props) => {
  /**
   * life translations up if needed
   */
  const t = useHealthTranslations();
  const { format } = useDateFormatter();
  const pastDebtHeaders = useMemo(
    () => [
      t('debtToEquityHistory.table.heading2'),
      t('debtToEquityHistory.table.heading3'),
      t('debtToEquityHistory.table.heading4'),
    ],
    [t]
  );
  const locale = useLocale();
  return (
    <div>
      <p>
        {t('debtToEquityHistory.modal.caption', {
          company: companyShortName,
          date: format(lastEarningsUpdate),
        })}
      </p>
      <RawDataTimeSeries
        uniqueSymbol={uniqueSymbol}
        title={t('debtToEquityHistory.modal.caption2')}
        reportingCurrencyISO={reportingCurrencyISO}
        reportingUnit={reportingUnit}
        numberPrecision={2}
        tableHeaderDescriptions={pastDebtHeaders}
        tableData={pastDebtAndEquityData}
        formatNumber={(value) => parseFloat(value).toLocaleString(locale)}
        formatDate={(date) => format(date)}
      />
    </div>
  );
};

export default HistoricalDebtEquityRawData;
